import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { FaPlus, FaCalendarAlt, FaTrash, FaInbox } from "react-icons/fa";
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import Table from 'react-bootstrap/Table';
import { useToasts } from 'react-toast-notifications';
import Moment from 'react-moment';
import Spinner from 'react-bootstrap/Spinner';
import Pagination from  '../../../components/Pagination/Pagination';

import { API } from 'aws-amplify';
import { Formik } from "formik";
import * as yup from "yup";

import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";
import DatePickerPopperContainer from '../../../components/DatePickerPopperContainer';

import '../../../components/PageHeader/PageHeader.css';
import PageHeader from '../../../components/PageHeader/PageHeader';
import { useI18n } from '../../../i18n';
import './CostAdd.css';
import { ITEMS_PER_PAGE } from '../../../localdb';

const CostAdd = (props) => {
    const { t } = useI18n();
    const { addToast } = useToasts();
    const [loading, setLoading] = useState(false);
    const [btnDisabled, setBtnDisabled] = useState(false);
    const [cost_date, setCostDate] = useState('');
    const [selCost, setSelCost] = useState([]);
    const [total_cost, setTotalCost] = useState(0);
    const [costs, setCosts] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const handleClose = () => {setShowModal(false); setSelCost([])}
    const handleShow = (cost) => {setShowModal(true); setSelCost(cost)}
	const [currentPage, setCurrentPage] = useState(1);
	const [currentYear, setCurrentYear] = useState(new Date());
    const [itemsPerPage] = useState(ITEMS_PER_PAGE);
    
    // const currentDate = new Date();

    const params = { 
        headers: {
        'x-api-key': process.env.REACT_APP_API_KEY,        
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        },
    }

    // Load costs 
    useEffect(()=>{
            API.get('costs','/', params)
            .then(res => { 
                
                const totalCosts = res.filter(item => {return new Date(item.date).getFullYear() === currentYear.getFullYear() }).reduce((sum, item) => {return sum = sum + parseFloat(item.cost) }, 0)
                setTotalCost(totalCosts);

                //sort array desc
                res.sort((a, b) => (a.date > b.date) ? 1 : -1)
                res.reverse();

                setCosts(res.filter(item => {return new Date(item.date).getFullYear() === currentYear.getFullYear() }));               
            });
            setLoading(false);
    }, [loading, currentYear]);

    const handleSubmit = (data, { resetForm }) => {

        data.userId = props.user.username;
        data.cost = parseFloat(data.cost);

       API.post('costs', '/', {      
           body: data,
           headers: {
            'x-api-key': process.env.REACT_APP_API_KEY,        
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            },
       })
       .then(response => {
        //    console.log(response)
           addToast(t('toast.costSaved'), { appearance: 'success' });
           setLoading(true);    
           resetForm(); 
           setCostDate('');  
       }).catch(error => {
           console.log(error)
           addToast(t('toast.errorSavingCost'), { appearance: 'error' });
       });          
       setBtnDisabled(false);
    };

    const deleteCost = (costId) => {
        //remove from db
        setShowModal(false);
        API.del('costs', '/' + costId, {       
            headers: {
                'x-api-key': process.env.REACT_APP_API_KEY,        
                'Accept': 'application/json',
            },
        })
        .then(response => {
            addToast(t('toast.costDeleted'), { appearance: 'success' });         
        }).catch(error => {
            console.log(error)
            addToast(t('toast.errorDeletingCost'), { appearance: 'error' });
        });

        //remove from the list
        const costFiltered = costs.filter((item) => item['costId'] !== costId);
        setCosts(costFiltered);

        const totalCosts = costFiltered.filter(item => {return new Date(item.date).getFullYear() === currentYear.getFullYear() }).reduce((sum, item) => {return sum = sum + parseFloat(item.cost) }, 0)
        setTotalCost(totalCosts);

    };

    // Pagination
    // Get current tasks
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentItemList = costs.slice(indexOfFirstItem, indexOfLastItem);

    // Change page
    const paginate = pageNumber => setCurrentPage(pageNumber);


    const schema = yup.object().shape({
    date: yup.string()
        .required(t('common.required')),
    description: yup.string()
        .required(t('common.required')),
    cost: yup.number()
        .typeError("This is not a valid number")
        .required(t('common.required')),
    });

        return (   
            
            <Formik               
            initialValues={{date: '',
                        description: '',
                        cost: '',
                        userId: '',
                        date_created: new Date().toISOString()}}
            validationSchema={schema}
            onSubmit={ (values, { setSubmitting, resetForm }) => {
                setBtnDisabled(true);
                handleSubmit(values, { resetForm });
                setSubmitting(false);
            }}

            >
            {({values, errors, touched, handleChange, handleBlur, handleSubmit, isSubmitting, setFieldValue, resetForm }) => (

        <div className="CostAdd">
        <form onSubmit={handleSubmit}>
        <PageHeader
            title={t('pages.preliminaries.title')}
            subtitle={t('pages.preliminaries.subtitle')}
            breadcrumbs={[
                { label: t('nav.costs') },
                { label: t('pages.preliminaries.title') },
            ]}
            count={!loading ? costs.length : undefined}
            countLabel={t('common.items')}
            countSingular={t('common.item')}
            countLoading={loading}
        />

        <div className="row div-content">
            <div className="col-lg-8 col-md-12">
                <div className="add-panel">
                    <div className="section-title">
                        <FaPlus /> {t('costsUi.addCost')}
                    </div>
                    <div className="row">
                        <div className="col-md-3 pb-3">
                            <Form.Group controlId="date" className={touched.date && errors.date ? "has-error" : null}>
                                <Form.Label className="form-label-date"><FaCalendarAlt className="text-secondary" /> {t('common.date')}</Form.Label>
                                <DatePicker
                                    dateFormat="dd/MM/yyyy"
                                    selected={cost_date}
                                    onChange={e => {
                                        setCostDate(e);
                                        setFieldValue('date', e, false);
                                    }}
                                    className="form-control"
                                    popperContainer={DatePickerPopperContainer}
                                    popperPlacement="bottom-start"
                                />
                                {touched.date && errors.date ? <div className="error-message">{errors.date}</div> : null}
                            </Form.Group>
                        </div>
                        <div className="col-md-5 pb-3">
                            <Form.Group controlId="description" className={touched.description && errors.description ? "has-error" : null}>
                                <Form.Label>{t('common.description')}</Form.Label>
                                <Form.Control
                                    as="input"
                                    value={values.description}
                                    placeholder={t('costsUi.enterDescription')}
                                    onChange={handleChange}
                                    type="text" />
                                {touched.description && errors.description ? <div className="error-message">{errors.description}</div> : null}
                            </Form.Group>
                        </div>
                        <div className="col-md-2 pb-3">
                            <Form.Group controlId="cost" className={touched.cost && errors.cost ? "has-error" : null}>
                                <Form.Label>{t('costsUi.costEuro')}</Form.Label>
                                <Form.Control
                                    as="input"
                                    value={values.cost}
                                    placeholder="0.00"
                                    onChange={handleChange}
                                    type="number"
                                    step="0.01"/>
                                {touched.cost && errors.cost ? <div className="error-message">{errors.cost}</div> : null}
                            </Form.Group>
                        </div>
                        <div className="col-md-2 add-btn-wrap">
                            <Button variant="success" type="submit" className="btn-add" disabled={btnDisabled}>
                                <FaPlus /> {t('actions.add')}
                            </Button>
                        </div>
                    </div>
                </div>
            </div>

            <div className="col-lg-4 col-md-12">
                <div className="summary-card">
                    <div className="summary-header">
                        <span>{t('fields.totalCost')}</span>
                        <DatePicker
                            selected={currentYear}
                            onChange={date => setCurrentYear(date)}
                            showYearPicker
                            dateFormat="yyyy"
                            className="year-picker"
                        />
                    </div>
                    <div className="summary-amount">€{total_cost.toFixed(2)}</div>
                    <div className="summary-subtext">{costs.length} {costs.length === 1 ? t('common.entry') : t('common.entries')} {currentYear.getFullYear()}</div>
                </div>
            </div>

            {(!loading) ? (
                (costs.length === 0) ? (
                    <div className="col-md-12 empty-state">
                        <FaInbox className="empty-state-icon" />
                        <div className="empty-state-text">{t('costsUi.noCosts')}</div>
                        <div className="empty-state-subtext">{t('costsUi.addHint')}</div>
                    </div>
                ) : (
                    <div className="col-md-12">
                        <Table responsive striped bordered hover variant="light" className="costs-table">
                            <thead>
                                <tr>
                                    <th>{t('common.date')}</th>
                                    <th>{t('common.description')}</th>
                                    <th className="text-right">{t('costsUi.costEuro')}</th>
                                    <th className="actions-col"></th>
                                </tr>
                            </thead>
                            <tbody>
                            {currentItemList.map((item, i) => (
                                <tr key={i}>
                                    <td className="text-nowrap"><Moment local format='DD-MM-YYYY' date={item.date} /></td>
                                    <td>{item.description}</td>
                                    <td className="text-right cost-value">{item.cost.toFixed(2)}</td>
                                    <td className="actions-col text-right">
                                        <Button size="sm" variant="danger" type="button" className="delete-btn" onClick={() => handleShow(item)}>
                                            <FaTrash />
                                        </Button>
                                    </td>
                                </tr>
                            ))}
                            </tbody>
                        </Table>

                        <Pagination
                            sizePerPage={itemsPerPage}
                            currentPage={currentPage}
                            totalSize={costs.length}
                            changeCurrentPage={paginate}
                            theme="bootstrap"
                        />
                    </div>
                )
            ) : (
                <div className="col-md-12 loading-container">
                    <div className="loading-content">
                        <Spinner animation="border" role="status" variant="primary" className="loading-spinner" />
                        <div className="loading-text">{t('costsUi.loading')}</div>
                        <div className="loading-subtext">{t('costsUi.pleaseWait')}</div>
                    </div>
                </div>
            )}

        <Modal className="cost-modal cost-modal-danger" show={showModal} onHide={handleClose} animation={false} centered>
            <Modal.Header closeButton>
                <Modal.Title>{t('costsUi.deleteTitle')}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {t('costsUi.deleteConfirm')}
                <div className="delete-preview">"{selCost.description}"</div>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={handleClose}>
                    {t('common.cancel')}
                </Button>
                <Button variant="danger" onClick={()=>deleteCost(selCost.costId)}>
                    {t('actions.delete')}
                </Button>
            </Modal.Footer>
        </Modal>

        </div>
        </form>
        </div>  
        )}
        </Formik>       
        );
    
}

const mapStateToProps = state => {
    return {
        user: state.auth.user,
    };
};

export default connect(mapStateToProps )(CostAdd);